<template>
  <div class="col-md-6 col-sm-6">
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <h5 class="card-title">Recent Created Groups</h5>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-stripped table-hover">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Reg Date</th>
                <th>Login Time</th>
                <th>Members</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="record in Indexgroup" :key="record.id">
                <td>
                  <h2 class="table-avatar">
                    <a href="javascript:;"
                      ><img
                        class="avatar avatar-sm me-2 avatar-img rounded-circle"
                        :src="require(`@/assets/admin_img/${record.Image}`)"
                        alt="User Image"
                      />{{ record.Name }}</a
                    >
                  </h2>
                </td>
                <td>{{ record.RegDate }}</td>
                <td>{{ record.LoginTime }}</td>
                <td>{{ record.Members }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Indexgroup from "@/assets/json/admin/indexgroup.json";
export default {
  data() {
    return {
      Indexgroup: Indexgroup,
    };
  },
};
</script>
